import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import { slugify } from '../../utils/slugify';
import { IMG_URL,END_URL } from "../../config.js";
import axios from 'axios';

import Subscriptions from '../Subscriptions/Subscriptions';

function BlogSideBar({ 
  topics, 
  selectedTopicId, 
  blog_adver, 
  selectedTopicAdd, 
  blog_adver_link, 
  selectedTopicLink,
  token,
  userdetail,
  onLoginChange,
  TestLink,
  TestLink1
}) {
  const navigate = useNavigate();
  const [topOffset, setTopOffset] = useState(140);
  const [isMobile, setIsMobile] = useState(false);

  const handleAdClick = (link) => {
    if (link) {
      window.location.href = `/${link}`;
    }
  };

  const subS = true;

  const [subscription, setSubscription] = useState(null);

  const [ShowModal, setShowModal] = useState(false);

  const handleNavigete = (link) => {
      
    if (link) {
      window.location.href = `/${link}`;
    }
  };


    const handleSub = async (subJson) => {
      try {
        setShowModal(true);

        let subIds = subJson;

        if (typeof subJson === "string") {
          try {
            subIds = JSON.parse(subJson);
          } catch (e) {
            console.error("Invalid JSON string for subIds:", e);
            return;
          }
        }

        if (!Array.isArray(subIds) || subIds.length === 0) {
          console.warn("No valid subscription IDs found:", subIds);
          return;
        }

        const res = await axios.post(
          `${END_URL}/sub_adver`,
          { ids: subIds },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setSubscription(res.data);
      } catch (err) {
        console.error("Error loading subscriptions:", err);
      }
    };


  const LoginShow = () => {

      window.scrollTo({ top: 0, behavior: 'smooth' });
      onLoginChange(true); 
  };

    const LoginShowSub = (subids) => {

      if (subids) {
          try {
          let parsedSubIds;

          if (typeof subids === "string") {
              try {
              parsedSubIds = JSON.parse(subids);
              } catch {
              parsedSubIds = [subids];
              }
          } else if (Array.isArray(subids)) {
              parsedSubIds = subids;
          } else {
              parsedSubIds = [subids];
          }

          localStorage.setItem("pendingSubIds", JSON.stringify(parsedSubIds));
          } catch (error) {
          console.error("Failed to save subids to localStorage:", error);
          }
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
      onLoginChange(true);
  };

  useEffect(() => {
    const updatePosition = () => {
      const dashboard = document.querySelector(".dashboard-header");
      const dashboardHeight = dashboard?.getBoundingClientRect?.()?.height || 0;
      const scrollY = window.scrollY || 0;
      const viewportHeight = window.innerHeight || 800;
      const docHeight = document.documentElement?.scrollHeight || document.body?.scrollHeight || 0;
      const distanceFromBottom = Math.max(0, docHeight - (scrollY + viewportHeight));

      let offset = dashboardHeight + 20;
      if (distanceFromBottom < 100) {
        offset = Math.max(0, offset - (100 - distanceFromBottom));
      }
      setTopOffset(Math.max(offset, 140));
    };

    updatePosition();

    const throttledUpdate = () => {
      requestAnimationFrame(updatePosition);
    };

    window.addEventListener("scroll", throttledUpdate, { passive: true });
    window.addEventListener("resize", throttledUpdate, { passive: true });

    document.body.style.setProperty("overflow-x", "visible", "important");
    document.documentElement.style.setProperty("overflow-x", "visible", "important");

    return () => {
      window.removeEventListener("scroll", throttledUpdate);
      window.removeEventListener("resize", throttledUpdate);
    };
  }, []);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener("resize", checkMobile);
    
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <div 
      className="col-12 col-sm-12 col-md-3 blog-card-row-side"
      style={{
        position: isMobile ? 'relative' : 'sticky',
        top: isMobile ? 'auto' : `${topOffset}px`,
        alignSelf: 'flex-start',
        zIndex: 100,
        transition: 'top 0.1s ease-out',
      }}
    >
      {topics.length > 0 && <h5>Topics</h5> }
      <ul> 
        {topics?.map(topic => (
          <li key={topic.id}>
            <a
              href="#"
              className={selectedTopicId === topic.id ? 'active' : ''}
              onClick={(e) => {
                e.preventDefault();
                const slug = slugify(topic.topicname);
                navigate(`/blog-topic/${slug}`);
              }}
              style={{
                fontWeight: selectedTopicId === topic.id ? 'bold' : 'normal',
              }}
            >
              {topic.topicname}
              <span><FontAwesomeIcon icon={faArrowRight} /></span>
            </a>
          </li>
        ))}
      </ul>

      {blog_adver && (
        <div 
          className="blog-adverts-div" 

            onClick={
              token
                ? (TestLink != "" && TestLink != null
                    ? () => handleNavigete(TestLink)
                    : () => handleSub(blog_adver_link))
                : ()=>LoginShowSub(blog_adver_link)
            }

          style={{ cursor: blog_adver_link ? 'pointer' : 'default' }}
        >
          <img src={`${IMG_URL}/d0/${blog_adver}`} alt="Advertisement" />
        </div>
      )}

      {selectedTopicAdd && (
        <div 
          className="blog-adverts-div test" 

          // onClick={() => handleAdClick(selectedTopicLink)}

          onClick={
            token
              ? (TestLink1 != "" && TestLink1 != null
                  ? () => handleNavigete(TestLink1)
                  : () => handleSub(selectedTopicLink))
                : ()=>LoginShowSub(selectedTopicLink)
          }

          style={{ cursor: selectedTopicLink ? 'pointer' : 'default' }}
        >
          <img src={`${IMG_URL}/d0/${selectedTopicAdd}`} alt="Advertisement" />
        </div>
      )}

        {ShowModal && (
                                  
        <div 
                  className={`newdashpop-overlay subs-cognit-modal1 modal_subcript ${
                   subscription?.data?.length == 1 ? "single-subscription" : ""
                  }`}
                
                >

                  <div className="newdashpop-inner">

                      <div className="newdashpop-container">

                          <button
                            className="newdashpop-close"
                            onClick={() => setShowModal(false)}
                            >
                            &times;
                        </button>

                        <div className="conent-pop">
                        
                           <Subscriptions subs={subS} userdetail={userdetail} Subcription={subscription} onLoginChange={onLoginChange}/>

                        </div>

                      </div>

                  </div>

              </div>
          )}


    </div>
  );
}

export default BlogSideBar;